import React from "react";
import { Mail, MapPin } from "lucide-react";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0B0E14] border-t border-[#1E293B]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
                    {/* Brand */}
                    <div className="md:col-span-2">
                        <div className="flex items-center mb-4">
                            <img
                                src="/bs-logo-v2.png"
                                alt="Badge & Shield Coffee Co."
                                className="h-16 w-auto object-contain"
                                style={{
                                    filter:
                                        "drop-shadow(0 2px 6px rgba(0,0,0,0.55))",
                                }}
                            />
                        </div>
                        <p className="font-body text-slate-400 max-w-md leading-relaxed">
                            Coffee roasted in honor of those who
                            answer the call. First-responder built.
                        </p>
                        <div className="bs-stencil-divider mt-8 mb-6 max-w-md" />
                        <div className="font-anton text-3xl uppercase tracking-[0.18em] text-[#ffffff]">
                            Duty. Honor. Coffee.
                        </div>
                    </div>

                    {/* Contact */}
                    <div>
                        <div className="bs-eyebrow mb-4">Contact</div>
                        <ul className="space-y-3 font-body text-sm text-slate-300">
                            <li className="flex items-start gap-2">
                                <MapPin className="w-4 h-4 text-[#ffffff] mt-0.5 flex-shrink-0" />
                                <span>
                                    PO Box 16115
                                    <br />
                                    Louisville, KY 40256
                                </span>
                            </li>
                            <li className="flex items-center gap-2">
                                <Mail className="w-4 h-4 text-[#ffffff] flex-shrink-0" />
                                <a
                                    href="mailto:badgeandshieldcoffee@gmail.com"
                                    data-testid="footer-email-link"
                                    className="hover:text-[#ffffff] transition-colors"
                                >
                                    badgeandshieldcoffee@gmail.com
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Links */}
                    <div>
                        <div className="bs-eyebrow mb-4">Quick Links</div>
                        <ul className="space-y-3 font-body text-sm text-slate-300">
                            {[
                                { label: "Shop Roasts", id: "products" },
                                {
                                    label: "First Responder Discount",
                                    id: "wholesale",
                                },
                                { label: "Our Mission", id: "mission" },
                                { label: "Contact", id: "contact" },
                            ].map((l) => (
                                <li key={l.id}>
                                    <button
                                        data-testid={`footer-link-${l.id}`}
                                        onClick={() =>
                                            document
                                                .getElementById(l.id)
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                })
                                        }
                                        className="hover:text-[#ffffff] transition-colors text-left"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="bs-stencil-divider mt-16 mb-6" />
                <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-body text-slate-500">
                    <div data-testid="footer-copyright">
                        © {new Date().getFullYear()} Badge & Shield Coffee
                        Company. All rights reserved.
                    </div>
                    <div className="font-chivo tracking-[0.24em] uppercase text-[10px]">
                        Roasted with discipline · Brewed with honor
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
